// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"AW-z","sponsoredTooltipWrapper":"BW-z","sponsoredTooltip":"CW-z","newCard":"DW-z"};